import Typography from "@mui/material/Typography";
import banner from "../../../assets/banner.png";
import notImage from "../../../assets/sem-foto.png";
import { useContext, useEffect, useState } from "react";
import React from "react";
import CardSys from "../../cardSys";
import SubTitleCard from "../../cardSys/subTitle";
import { Grid } from "@mui/material";
import { api } from "../../../services/api";
import { apiUrl } from "../../../services/apiUrl";
import CloseButtonFilter from "../../generic/closeButtonFilter";
import { AuthContext } from "../../../contexts/AuthContext";
import SubTitleCardPdf from "../../cardSysPdf/subTitle";

export default function CardHeader({
  children,
  enterpriseSelected,
  closeFilter,
  setEnterpriseSelected,
  ...props
}) {
  const [typeDashboard, setTypeDashboard] = useState("Relatório Estatístico");
  const [dashboardPeriod, setDashboardPeriod] = useState(
    "Novembro/2022" - "Dezembro/202"
  );
  const [typeDashboardWallet, setTypeDashboardWallet] = useState(
    "Relatório de Acompanhamento de Carteira"
  );
  const [cnpj, setCnpj] = useState("06.248.609/0001-60");
  const [enterprise, setEnterprise] = useState({});

  const { user } = useContext(AuthContext);

  useEffect(() => {
    if (enterpriseSelected) {
      getEnterpriseById();
    }
  }, [enterpriseSelected]);

  const getEnterpriseById = async () => {
    try {
      const idClient = enterpriseSelected;
      let data = {
        id_client: enterpriseSelected,
      };

      const { data: response } = await api({
        method: "POST",
        url: "/source/client",
        data,
      });
      localStorage.setItem("PreviewPDFClient", JSON.stringify(response));
      setEnterpriseSelected(response);
      setEnterprise(response);
    } catch (err) {}
  };

  return (
    <CardSys>
      <Grid container>
        <Grid item sm={10} xs={10}>
        <Grid container>
          <Grid item sx={{ marginLeft: "10px" }} xs={12}>
            <Grid container spacing={1}>
              <Grid sx={{ fontSize: "1rem", fontWeight: "bold" }} item xs={8}>
                Nome Fantasia
              </Grid>
              <Grid sx={{ fontSize: "1rem", fontWeight: "bold" }} item xs={2}>
                CNPJ
              </Grid>
              <Grid sx={{ fontSize: "1rem", fontWeight: "bold" }} item xs={2}>
                Início das Atividades
              </Grid>
            </Grid>
          </Grid>
          {Object.keys(enterprise)?.map((index) => {
            return (
              <Grid item xs={12}>
                <Grid container spacing={2}>
                  <Grid item xs={8}>
                    <Typography sx={{ marginLeft: "10px",color:"#2C4992" }}>
                      {enterprise[index].razao_social}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography sx={{ marginRight: "10px",color:"#2C4992" }}>
                      {enterprise[index].pes_cpfcnpj}
                    </Typography>
                  </Grid>
                  <Grid item xs={2}>
                    <Typography sx={{color:"#2C4992"}}>{enterprise[index].data_inicio}</Typography>
                  </Grid>
                </Grid>
              </Grid>
            );
          })}
        </Grid>
        </Grid>
        <Grid item sm={2} xs={2}>
          {children}
        </Grid>
      </Grid>
    </CardSys>
  );
}
